import React, { Component } from "react";
import { LinkedIn } from "react-linkedin-login-oauth2";
import {
	FacebookShareButton,
	TwitterShareButton,
	WhatsappShareButton,
} from "react-share";
import {
	getLinkedInUserIdProxy,
	getLinkedInAccessTokenProxy,
	getLinkedInAccessToken,
} from "../../services/verifiedBackendService/linkedin";
import { handleShareAnon } from "../../services/verifiedBackendService/event";

import { getMasterConfig } from "wallet-elementkit/dist/constants/master";
import { ReactComponent as TwitterLogo } from "../../assets/socials/twitter-black.svg";
import "../../styles/components/shareIcons.scss";
import { Subdomains } from "wallet-elementkit/dist/constants";
const masterConfig = getMasterConfig();

export default class ShareIcons extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	handleDesc = (tag) => {
		if (masterConfig.subDomain === Subdomains.philipMorris) return "";
		const skillTags =
			(this.props.skills &&
				this.props.skills.reduce((tags, skill) => {
					return (tags += `#${skill.title
						.toLocaleLowerCase()
						.replace(/\s+/g, "")} `);
				}, "")) ||
			"";
		let via = "@sertifier";
		if (tag === "linkedin") {
			via = "sertifier";
		} else if (tag === "facebook") {
			if (this.props.language && this.props.language.code === "tr")
				via = "@sertifiertr";
			else via = "@sertifierco";
		} else if (tag === "twitter") {
			if (this.props.language && this.props.language.code === "tr")
				via = "@sertifiertr";
			else via = "@sertifier";
		} else via = "sertifier";

		if (this.props.language && this.props.language.code === "tr")
			return this.props.isCollection
				? `${this.props.issuer} tarafından ${via} aracılığıyla verilen Verified koleksiyonuma göz at!\n${skillTags}\n`
				: this.props.shareText
				? this.props.shareText
				: `${this.props.issuer} tarafından ${via} aracılığıyla verilen ${this.props.certTitle} başlıklı dijital sertifika/rozetime göz at!\n${skillTags}\n`;
		else
			return this.props.isCollection
				? `Check out my verified collection issued by ${this.props.issuer} via ${via}!\n${skillTags}\n`
				: this.props.shareText
				? this.props.shareText
				: `Check out my ${this.props.certTitle} digital certificate/badge issued by ${this.props.issuer} via ${via}!\n${skillTags}\n`;
	};
	handleClick = async (sharingFor) => {
		let { credential_no } = this.props;
		let res = await handleShareAnon(
			sharingFor,
			credential_no,
			this.props.organizationId
		);
		// let resJson = await res.json();
	};
	shareOnYammer = () => {
		this.handleClick("yammer");
		window.yam.platform.yammerShareOpenPopup({
			defaultMessage: this.handleDesc("yammer"),
			pageUrl: window.location.href,
		});
	};
	render() {
		let { url, certTitle } = this.props;
		return (
			<div className="share-icons-main">
				{this.props.linkedinAuthCode && this.props.linkedinAuthCode !== "" ? (
					<img
						alt=""
						onClick={async () => {
							await getLinkedInAccessTokenProxy(
								this.props.linkedinAuthCode
							).then(async (tokenCode) => {
								this.props.setLinkedinToken(tokenCode);
								await getLinkedInUserIdProxy(tokenCode).then(async (userId) => {
									this.props.setLinkedinUserId(userId);
									this.props.openDialog();
								});
							});
						}}
						className="social-icon"
						src={require("../../assets/socials/linkedin_black.svg").default}
					/>
				) : (
					<LinkedIn
						clientId="775jdov7xhw33h"
						redirectUri={`https://verified.sertifier.com/en/linkedinBounce?redirect_to=${
							window.location.href.toString().split("?")[0]
						}`}
						onSuccess={async (code) => {
							await getLinkedInAccessToken(code).then(async (tokenCode) => {
								this.props.setLinkedinToken(tokenCode);
								await getLinkedInUserIdProxy(tokenCode).then(async (userId) => {
									this.props.setLinkedinUserId(userId);
									this.props.openDialog();
								});
							});
						}}
						scope="r_emailaddress r_liteprofile w_member_social"
						closePopupMessage="Close Pop Up"
						onError={(error) => {
							console.log(error);
						}}
					>
						{({ linkedInLogin }) => (
							<img
								alt=""
								onClick={linkedInLogin}
								className="social-icon"
								src={require("../../assets/socials/linkedin_black.svg").default}
							/>
						)}
					</LinkedIn>
				)}

				<TwitterShareButton
					onClick={() => this.handleClick("twitter")}
					title={this.handleDesc("twitter")}
					related={["sertifier"]}
					url={url}
				>
					<TwitterLogo className="social-icon twitter-icon" />
				</TwitterShareButton>

				<FacebookShareButton
					onClick={() => this.handleClick("facebook")}
					quote={this.handleDesc("facebook")}
					url={url}
				>
					<img
						alt=""
						className="social-icon"
						src={require("../../assets/socials/facebook_black.svg").default}
					/>
				</FacebookShareButton>

				<WhatsappShareButton
					onClick={() => this.handleClick("whatsapp")}
					title={this.handleDesc("whatsapp")}
					url={url}
				>
					<img
						alt=""
						className="social-icon"
						src={require("../../assets/socials/whatsapp_black.svg").default}
					/>
				</WhatsappShareButton>
				<img
					alt=""
					src={require("../../assets/socials/yammer_black.svg").default}
					className="social-icon"
					style={{ cursor: "pointer" }}
					onClick={() => this.shareOnYammer()}
				/>
				<a
					onClick={() => this.handleClick("xing")}
					target="_blank"
					href={`https://www.xing.com/spi/shares/new?url=${this.props.url}`}
				>
					<img
						alt=""
						src={require("../../assets/socials/xing_black.svg").default}
						className="social-icon"
					/>
				</a>
			</div>
		);
	}
}
